module.exports = __webpack_public_path__ + "img/p27.8cada5aa.png";